import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona para presupuestos pequeños?',
    a: 'Sí, Andromeda es ideal para maximizar cada dólar desde los $10-$20 diarios.'
  }, {
    q: '¿Necesito saber de programación?',
    a: 'Nada. Es 100% estrategia de mensaje y configuración básica.'
  }, {
    q: '¿Sirve para cualquier nicho?',
    a: 'Si tu cliente es un ser humano con una identidad y dolores específicos, funciona.'
  }, {
    q: '¿Qué pasa si mi cuenta es nueva?',
    a: 'Es el mejor momento; empezarás entrenando a tu píxel con datos de alta calidad desde el día 1.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-[#0d1117]/50 border-y border-white/5" data-id="element-4">
      <div className="max-w-3xl mx-auto" data-id="element-5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-6">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-7">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-8">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#161b22] border border-white/5 rounded-2xl overflow-hidden" data-id="element-9">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-10">
                <span className="text-lg font-semibold text-white" data-id="element-11">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-12" />
              </button>

              <AnimatePresence data-id="element-13">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-14">
                    <div className="px-6 pb-5 text-slate-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-15">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}